import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { motion } from "framer-motion";

import "react-vertical-timeline-component/style.min.css";

import { styles } from "../styles";
import { agencyExperiences } from "../constants";
import { SectionWrapper } from "../hoc";
import { textVariant } from "../utils/motion";
import { useTheme } from "../context/ThemeContext";

const ExperienceCard = ({ experience, theme }) => {
  return (
    <VerticalTimelineElement
      contentStyle={{
        background: "var(--color-timeline-glass-bg)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: "1px solid var(--color-glass-border)",
        boxShadow: "var(--shadow-glass-card)",
        borderRadius: "18px",
      }}
      contentArrowStyle={{ borderRight: "7px solid var(--color-timeline-arrow)" }}
      date={
        <div className="cursor-default text-foreground-muted">{experience.date}</div>
      }
      iconStyle={{ background: experience.iconBg }}
      icon={
        <div className="flex justify-center items-center w-full h-full">
          <img
            src={experience.icon}
            alt={experience.company_name}
            className="w-[60%] h-[60%] object-contain"
          />
        </div>
      }
    >
      <div>
        <h3 className="text-foreground text-[24px] font-bold cursor-default">
          {experience.title}
        </h3>
        <p
          className="text-secondary text-[16px] font-semibold cursor-default"
          style={{ margin: 0 }}
        >
          {experience.company_name}
        </p>
      </div>

      <p className="mt-5 text-foreground-muted text-[14px] tracking-wider leading-relaxed cursor-default">
        {experience.points[0]}
      </p>
    </VerticalTimelineElement>
  );
};

const ExperienceSection = () => {
  const { theme } = useTheme();

  return (
    <div>
      <motion.div variants={textVariant()}>
        <h2 className={`${styles.sectionHeadText} text-center cursor-default`}>
          Mi experiencia
        </h2>
      </motion.div>

      <div className="mt-10 flex flex-col">
        <VerticalTimeline animate={window.innerWidth > 768} lineColor="var(--color-timeline-line)">
          {agencyExperiences.map((experience, index) => (
            <ExperienceCard
              key={`experience-${index}`}
              experience={experience}
              theme={theme}
            />
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
};

const Experience = SectionWrapper(ExperienceSection, "experiencia", 0.05, "sm:py-8 py-4");
export default Experience;
